import React from "react";
import "./PromotedByBanner.css";

// Optional logo
import ASG from "@/assets/images/ASG-Logo.png";

const Promoted = () => {
  return (
    <div className="promoted-wrapper ">
      <div className="promoted-card">
        <div className="promoted-content py-0 lg:py-20">
          {/* Top Label */}
          <div className="promoted-label-wrapper">
            <span className="promoted-line"></span>

            <span className="promoted-label">PROMOTED BY</span>

            <span className="promoted-line"></span>
          </div>

          {/* Main Title */}
          <img src={ASG} alt="Brion Enterprises" className="h-12 w-auto" />
          {/* <h2 className="promoted-title">
            Atul Sheth Group
          </h2> */}
        </div>
      </div>
    </div>
  );
};

export default Promoted;
